import { createReducer } from "reduxsauce";

import ReducerRegister from "../../ReducerRegister";
import EditRoomMemberService from "../../../services/screens/chinesepark/EditRoomMemberService";
import { ActionTypes } from "../../actionTypes/screens/chinesepark/EditRoomMemberActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.chinesepark.editroommember;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditRoomMemberService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    createStudent: (classId, roomId) => ({
        type: ActionTypes.CREATE_STUDENT,
        classId,
        roomId
    }),

    saveStudentAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_STUDENT_ASYNC, vo });

            EditRoomMemberService.saveStudent(
                vo,
                response => {
                    dispatch(Actions.saveStudentSuccess(response));
                },
                error => {
                    dispatch(Actions.saveStudentFailure(error));
                }
            );
        };
    },

    saveStudentSuccess: data => ({
        type: ActionTypes.SAVE_STUDENT_SUCCESS,
        parentType: ActionTypes.SAVE_STUDENT_ASYNC,
        data
    }),

    saveStudentFailure: error => ({
        type: ActionTypes.SAVE_STUDENT_FAILURE,
        parentType: ActionTypes.SAVE_STUDENT_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    student: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, student: data.student };
};

const createStudentReducer = (state, { classId, roomId }) => {
    return { ...state, student: { classId, roomId } };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_STUDENT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_STUDENT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_STUDENT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_STUDENT]: createStudentReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
